// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2pA2b","col":"Table_col__1XVT9","fulfillmentStatus":"Table_fulfillmentStatus__38sxR","emailCol":"Table_emailCol__2sSS3"};